import {
  IEgdApiClient,
  AdapterCollection,
  AccountSettingsForm,
  DomainSettingsForm,
  RadioButtonStatesAdapter,
  settings,
  StringAdapter,
  SchemaFactory,
  IAuth
} from 'v2/modules/lib'

export interface IDefaultPolicyFormArgs {
  egdApiClient: IEgdApiClient
  accountId: string
  domainId: number | null
  auth: IAuth
}

export const DefaultPolicyForm = ({ egdApiClient, accountId, domainId, auth }: IDefaultPolicyFormArgs) => {
  const schema = SchemaFactory.fromSettings([
    settings.default_managed_scan_policy,
    settings.default_unmanaged_scan_policy,
    settings.default_user_exempt_enabled,
    settings.default_user_block_enabled,
    settings.default_user_deliver_enabled,
    settings.default_user_quar_deliver_enabled,
    settings.default_timezone
  ])

  const adapters = AdapterCollection()
  adapters.add(StringAdapter(settings.default_managed_scan_policy))
  adapters.add(StringAdapter(settings.default_unmanaged_scan_policy))
  adapters.add(StringAdapter(settings.default_user_exempt_enabled))
  adapters.add(RadioButtonStatesAdapter(settings.default_user_block_enabled))
  adapters.add(RadioButtonStatesAdapter(settings.default_user_deliver_enabled))
  adapters.add(RadioButtonStatesAdapter(settings.default_user_quar_deliver_enabled))
  adapters.add(StringAdapter(settings.default_timezone))

  adapters.add(
    StringAdapter({
      ...settings.qns_timezone,
      inputName: 'defaultTimezone',
      skipFormPopulateOnLoad: true
    })
  )
  adapters.add(
    StringAdapter({
      ...settings.allow_whitelist,
      inputName: 'defaultUserExemptEnabled',
      skipFormPopulateOnLoad: true
    })
  )

  if (domainId) {
    return {
      form: DomainSettingsForm({
        egdApiClient,
        accountId,
        domainId,
        adapters,
        auth
      }),
      schema
    }
  }
  return {
    form: AccountSettingsForm({
      egdApiClient,
      accountId,
      adapters,
      auth
    }),
    schema
  }
}

export type IDefaultPolicyForm = ReturnType<typeof DefaultPolicyForm>
